import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import { Row, Col, Card, Table, Button, Spinner, Modal } from 'react-bootstrap';
import classNames from 'classnames';
import Flex from '../../common/Flex';
import Avatar from "../../common/Avatar";
import ActionButton from "../../common/ActionButton";
import { item } from "../../../lib/api/entities";
import {contactType, list, remove} from "../../../lib/api/contact";
import { Add } from './Add';
import { Edit } from './Edit';


export const List = ({ initPartner, onClose}) => {

    console.log('initPartner',initPartner)
    const [partner, setPartner] = useState({});
    const [entitieContacts, setEntitieContacts] = useState([]);
    const [isLoading, setIsLoading] = useState(false);
    const [showModal, setShowModal] = useState(false);
    const [contact, setContact] = useState(null);
    const [entities, setEntities] = useState(null);
    const [contType, setContType] = useState([]);

    const handleNew = () => {
        setContact(null);
        setShowModal(true);
    };

    const handleEdit = (id) => {
        const _contact = entitieContacts.find(c => c.contact_guid === id);
        console.log('_contact',_contact)
        setContact(_contact);
        setShowModal(true);
    };

    const handelDelete = async (id) => {
        setIsLoading(true);
        try {
            if (confirm("Da li ste sigurni da želite da izbrišete kontakt?")) {
                await remove(id);
                setEntitieContacts(entitieContacts.filter((item) => item.contact_guid !== id));
            }
        } catch (error) {
            console.error("Failed to delete item", error);
        } finally {
            setIsLoading(false);
        }
    };

    const getEntities = () => {
        setIsLoading(true);
        item(partner.entities_guide)
            .then((res) => setEntities(res))
            .catch((err) => console.error(err))
    };

    const getContacts = () => {
        list(partner.entities_guide)
            .then((res) => setEntitieContacts(res))
            .catch((err) => console.error(err))
    };

    useEffect(() => {
        console.log('ID iz URL-a:', initPartner,partner);

        if (!initPartner || !initPartner.entities_guide) {
            console.log('initPartner još nije spreman, skipujem...');
            return;
        }

        (async () => {
            setPartner(initPartner);
            setIsLoading(true);
            const resEntities = await item(initPartner.entities_guide);
            setEntities(resEntities);
            const resContacts = await list(initPartner.entities_guide);
            setEntitieContacts(resContacts);
            const resContType = await contactType(resEntities.entities_type_id);
            setContType(resContType);
            setIsLoading(false);
        })();
    }, [initPartner]);

    const renderActions = item => (
        <>
            <ActionButton
                onClick={() => handleEdit(item.contact_guid)}
                icon="edit"
                title="Edit"
                variant="action"
                className="p-0 me-2"
            />
            <ActionButton
                onClick={() => handelDelete(item.contact_guid)}
                icon="trash-alt"
                title="Delete"
                variant="action"
                className="p-0"
            />
        </>
    );

    return (
        <Card className={classNames('h-100')}>
            <Card.Header>
                <Row className={classNames('g-2')}>
                    <Col>
                        <Flex>
                            <h5 className="mb-0 hover-actions-trigger text-truncate text-nowrap">
                                {entities ? entities.ent_name : <Spinner size="sm" />}
                            </h5>
                        </Flex>
                    </Col>
                    <Col xs="auto">
                        <Button onClick={handleNew} variant="primary">
                            +
                        </Button>
                    </Col>
                </Row>
            </Card.Header>
            <Card.Body className="bg-body-tertiary">
                {isLoading ? (
                    <div className="text-center">
                        <Spinner animation="border" role="status" />
                    </div>
                ) : (
                    <Row className="mb-3">
                        <div className="d-none d-xl-block">
                            <Table responsive>
                                <thead>
                                <tr>
                                    {contType.length > 1 ? (
                                        <th scope="col">Ime</th>
                                    ) : null}
                                    <th scope="col">Phone 1</th>
                                    <th scope="col">Phone 2</th>
                                    <th scope="col">Phone 3</th>
                                    <th scope="col">Email</th>
                                    <th className="text-end" scope="col">Akcija</th>
                                </tr>
                                </thead>
                                <tbody>
                                {entitieContacts.map((item, i) => (
                                    <tr key={i}>
                                        {contType.length > 1 ? (
                                            <td className="text-nowrap">
                                                <div className="d-flex align-items-center">
                                                    <div className="ms-2">{item.name}</div>
                                                </div>
                                            </td>
                                        ) : null}
                                        <td>
                                            <div className="ms-2">{item.phone_1}</div>
                                        </td>
                                        <td>
                                            <div className="ms-2">{item.phone_2}</div>
                                        </td>
                                        <td>
                                            <div className="ms-2">{item.phone_3}</div>
                                        </td>
                                        <td>
                                            <div className="ms-2">{item.email}</div>
                                        </td>

                                        <td className="text-end">{renderActions(item)}</td>
                                    </tr>
                                ))}
                                </tbody>
                            </Table>
                        </div>

                        <div className="d-xl-none">
                            <Row className="g-3">
                                {entitieContacts.map((item, i) => (
                                    <Col xs={12} key={i}>
                                        <div
                                            className="border rounded-4 bg-white h-100 p-3 shadow-sm"
                                            style={{ borderColor: '#dfe3ee' }}
                                        >
                                            <div className="d-flex align-items-start justify-content-between gap-3">
                                                <div className="flex-grow-1" style={{ minWidth: 0 }}>
                                                    <div className="fw-semibold text-dark fs-8">
                                                        {contType.length > 1 ? item.name : 'Kontakt'}
                                                    </div>
                                                </div>
                                                <div className="d-flex align-items-center flex-shrink-0">
                                                    {renderActions(item)}
                                                </div>
                                            </div>

                                            <div className="mt-3">
                                                {item.phone_1 && (
                                                    <div className="text-700 fs-10">{item.phone_1}</div>
                                                )}
                                                {item.phone_2 && (
                                                    <div className="text-600 fs-10 mt-1">{item.phone_2}</div>
                                                )}
                                                {item.phone_3 && (
                                                    <div className="text-600 fs-10 mt-1">{item.phone_3}</div>
                                                )}
                                                {item.email && (
                                                    <div className="text-600 fs-10 mt-2">{item.email}</div>
                                                )}
                                            </div>
                                        </div>
                                    </Col>
                                ))}
                            </Row>
                        </div>
                    </Row>
                )}
            </Card.Body>

            <Modal show={showModal} onHide={() => setShowModal(false)} size="lg">
                <Modal.Header closeButton>
                    <Modal.Title>{contact ? 'Izmijeni kontakt' : 'Dodaj kontakt'}</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    {contact ? (
                        <Edit
                            initEntities={entities}
                            initContact={contact}
                            onClose={() => setShowModal(false)}
                            onSave={getContacts}
                        />
                    ) : (
                        <Add
                            initEntities={entities}
                            onClose={() => setShowModal(false)}
                            onSave={getContacts}
                        />
                    )}
                </Modal.Body>
            </Modal>
        </Card>
    );
};

export default List;
